export const indicatorOfUnexecutedTasks = (data) => {
  const dias = data?.dias ?? [];
  const categorias = data?.categories ?? [];
  const catA = data?.catA ?? [];
  const catB = data?.catB ?? [];
  const catC = data?.catC ?? [];
  const catD = data?.catD ?? [];

  const totales = dias.length
    ? dias.map(
        (_, i) =>
          (catA[i] || 0) + (catB[i] || 0) + (catC[i] || 0) + (catD[i] || 0)
      )
    : [];

  return {
    chart: {
      spacingTop: 24,
      events: {
        render: function () {
          const chart = this;
          if (chart.customLabel) chart.customLabel.destroy();

          chart.customLabel = chart.renderer
            .text("", chart.plotLeft + chart.plotWidth / 2, chart.plotTop - 10)
            .attr({ align: "center" })
            .css({
              color: "#444",
              fontSize: "13px",
              fontFamily: "Arial, sans-serif",
            })
            .add();
        },
      },
    },
    title: {
      text: "Tareas planificadas NO ejecutadas",
      style: { fontSize: "18px", fontWeight: "bold" },
    },
    subtitle: {
      text: "Apilado por categoría (A, B, C, D).",
      style: { color: "#666" },
    },

    xAxis: {
      categories: categorias,
      tickmarkPlacement: "on",
      labels: { useHTML: true },
      crosshair: true,
    },

    yAxis: {
      min: 0,
      title: { text: "Cantidad de tareas no ejecutadas" },
      stackLabels: {
        enabled: true,
        style: { fontWeight: "bold" },
        formatter: function () {
          return this.total > 0 ? this.total : "";
        },
      },
    },

    legend: { align: "center", verticalAlign: "bottom" },

    tooltip: {
      shared: true,
      useHTML: true,
      headerFormat: "<b>{point.key}</b><br/>",
      formatter: function () {
        const points = this.points || [];
        let html = `<b>${this.x}</b><br/>`;

        let total = 0;

        points.forEach((p) => {
          if (p.y > 0) {
            html += `<span style="color:${p.color}">\u25CF</span> ${p.series.name}: <b>${p.y}</b><br/>`;
            total += p.y;
          }
        });

        html += `<hr style="margin:4px 0"/>`;

        return html;
      },
    },

    plotOptions: {
      column: {
        stacking: "normal",
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          style: { textOutline: "none", fontSize: "10px" },
          formatter: function () {
            return this.total > 0 && this.y / this.total >= 0.5 ? this.y : null;
          },
        },
      },
      series: { pointPadding: 0.05, groupPadding: 0.1 },
    },

    series: [
      { type: "column", name: "Categoría A", data: catA, color: "#2E86DE" },
      { type: "column", name: "Categoría B", data: catB, color: "#8E44AD" },
      { type: "column", name: "Categoría C", data: catC, color: "#27AE60" },
      { type: "column", name: "Categoría D", data: catD, color: "#E67E22" },
      {
        type: "spline",
        name: "Total diario",
        data: totales,
        marker: { enabled: true, radius: 3 },
        color: "#34495E",
        tooltip: { pointFormat: "Total diario: <b>{point.y}</b><br/>" },
        dataLabels: {
          enabled: true,
          formatter: function () {
            return this.y > 0 ? this.y : "";
          },
          style: { fontSize: "10px", color: "#34495E", textOutline: "none" },
        },
      },
    ],
  };
};
